// extracted by mini-css-extract-plugin
export default {"title":"ExitPageModal_title__QvicX","btnGroup":"ExitPageModal_btnGroup__+jSAW","btn":"ExitPageModal_btn__GG170"};